import { useEffect, useState, useRef } from 'react';
import styles from '@features/layout/components/Layout/components/NavigationContainer/NavigationContainer.styles';
type PropsType = {
  children: React.ReactNode;
  positionTop: number;
  isProductCardOpened: boolean;
  navigationContainerIsStatic: boolean;
  setNavigationContainerIsStatic: (value: boolean) => void;
  navigationContainerIsVisible: boolean;
  setNavigationContainerIsVisible: (value: boolean) => void;
  setNavigationContainerHeight: (value: number) => void;
  isMenuMobileOpened: boolean;
  isMenuPined: boolean;
  isLoginGeneralOpened: boolean;
  isSearchOpened: boolean;
  userPanelOpened: boolean;
};
const NavigationContainer = ({
  children,
  positionTop,
  isProductCardOpened,
  navigationContainerIsStatic,
  setNavigationContainerIsStatic,
  navigationContainerIsVisible,
  setNavigationContainerIsVisible,
  setNavigationContainerHeight,
  isMenuMobileOpened,
  isMenuPined,
  isLoginGeneralOpened,
  isSearchOpened,
  userPanelOpened
}: PropsType) => {
  const [lastScrollY, setlastScrollY] = useState(0);
  const [miniScrollY, setMiniScrollY] = useState(300);
  const [keepContainerSize, setKeepContainerSize] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  let timeOut: NodeJS.Timeout | null;
  const handleTimeOut = (isStaticValue: boolean, isVisibleValue: boolean, time = 200) => {
    if (timeOut) {
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(() => {
      setNavigationContainerIsStatic(isStaticValue);
      setNavigationContainerIsVisible(isVisibleValue);
    }, time);
  };
  const handleScroll = () => {
    if (!isProductCardOpened) {
      if (isMenuMobileOpened || isMenuPined || isLoginGeneralOpened || userPanelOpened || isSearchOpened || Math.abs(lastScrollY - window.scrollY) < 50) return;
      if (window.scrollY < lastScrollY && window.scrollY > miniScrollY) {
        handleTimeOut(false, true);
        setKeepContainerSize(false);
      } else {
        const staticVlue = window.scrollY <= miniScrollY;
        handleTimeOut(staticVlue, false, 400);
        if (navigationContainerIsVisible && !navigationContainerIsStatic) {
          setKeepContainerSize(true);
        } else {
          setKeepContainerSize(false);
        }
      }
      setlastScrollY(window.scrollY);
    } else {
      window.removeEventListener('scroll', handleScroll);
    }
  };
  const handleResize = () => {
    if (!isProductCardOpened) {
      if (window?.innerHeight) {
        setMiniScrollY(window.innerHeight);
      }
      if (containerRef?.current?.clientHeight) {
        setNavigationContainerHeight(containerRef?.current?.clientHeight);
      }
    } else {
      window.removeEventListener('resize', handleResize);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      if (timeOut) {
        clearTimeout(timeOut);
      }
    };
  });
  useEffect(() => {
    if (containerRef?.current?.clientHeight) {
      handleResize();
    }
  }, [containerRef?.current?.clientHeight]);
  return <>
      <div sx={styles.container(navigationContainerIsStatic, navigationContainerIsVisible, positionTop, keepContainerSize, isSearchOpened || isMenuMobileOpened || isMenuPined || isLoginGeneralOpened || userPanelOpened)} ref={containerRef}>
        {children}
      </div>
    </>;
};
export default NavigationContainer;